import {
    DOMAIN,
    Header,
    ContentType,
    GetFormData,
    Method,
    http
} from './api-utils';
import AuthUtil  from "@/utils/AuthUtil";
import userStore from '@/stores/UserStore.js'

/**
 * 登录
 * @param {*} param0
 */
export const login = async ({username, password}) => {
    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/login',
        data: {
            username,
            password
        }
    });
    AuthUtil.setToken("token")
    userStore.loadData()
};

/**
 * 退出登录
 */
export const logout = async () => {
    await http({
        method: Method.GET,
        url: DOMAIN + '/api/user/logout'
    });
    AuthUtil.removeAuth()
    userStore.loadData()
};

/**
 * 注册
 * @param {*} param0
 */
export const register = async ({
                                   username,
                                   password,
                               }) => {
    const formData = GetFormData({
        username,
        password
    });

    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/register',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });
    AuthUtil.setToken("token")
    userStore.loadData()
};